"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const define_1 = __importDefault(require("./define"));
const socket_1 = __importDefault(require("../socket"));
const state_1 = __importDefault(require("../state"));
const tick_1 = __importDefault(require("./tick"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const getAudioSource_1 = __importDefault(require("./definables/getAudioSource"));
const focusScreen_1 = __importDefault(require("./focusScreen"));
const isRunningOnLocal_1 = __importDefault(require("./isRunningOnLocal"));
const handleAction_1 = __importDefault(require("./handleAction"));
const credits_1 = __importDefault(require("../constants/credits"));
const assetsAreLoaded_1 = __importDefault(require("./assetsAreLoaded"));
const levelIsCompleted_1 = __importDefault(require("./levelIsCompleted"));
const gameIsOngoing_1 = __importDefault(require("./gameIsOngoing"));
const isPaused_1 = __importDefault(require("./isPaused"));
const pause_1 = __importDefault(require("./pause"));
const unpause_1 = __importDefault(require("./unpause"));
const getAudioSources_1 = __importDefault(require("./definables/getAudioSources"));
const getMusicTracks_1 = __importDefault(require("./definables/getMusicTracks"));
const getNoises_1 = __importDefault(require("./definables/getNoises"));
const startLevel_1 = __importDefault(require("./startLevel"));
const sizeScreen_1 = __importDefault(require("./sizeScreen"));
const levels_1 = __importDefault(require("../constants/levels"));
const run = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    console.log(`Running ScatterPaws.`);
    (0, define_1.default)();
    pixi_js_1.settings.ROUND_PIXELS = true;
    pixi_js_1.settings.SCALE_MODE = pixi_js_1.SCALE_MODES.NEAREST;
    pixi_js_1.utils.skipHello();
    state_1.default.app = new pixi_js_1.Application({
        backgroundAlpha: 0,
        height: gameHeight_1.default,
        width: gameWidth_1.default
    });
    state_1.default.app.renderer.view.style.display = "block";
    state_1.default.app.renderer.view.style.height = "100%";
    state_1.default.app.renderer.view.style.width = "100%";
    state_1.default.app.renderer.view.tabIndex = 0;
    state_1.default.app.renderer.view.addEventListener("contextmenu", (e) => {
        e.preventDefault();
    });
    const loader = new pixi_js_1.Loader;
    loader.add((0, isRunningOnLocal_1.default)() ? "./out/fonts/RetroPixels.fnt" : "./fonts/RetroPixels.fnt").load(() => {
        var _a, _b;
        state_1.default.loadedAssets++;
        if ((0, assetsAreLoaded_1.default)()) {
            (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("loading");
            (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.add("focus");
        }
    });
    state_1.default.app.ticker.add(tick_1.default);
    const screen = document.getElementById("screen");
    const pauseButton = document.getElementById("pause");
    const unpauseButton = document.getElementById("unpause");
    addEventListener("resize", () => {
        (0, sizeScreen_1.default)();
    });
    (_a = document.getElementById("mute")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
        (0, getAudioSources_1.default)().forEach((audioSource) => {
            audioSource.toggleMute();
        });
    });
    (_b = document.getElementById("main-volume")) === null || _b === void 0 ? void 0 : _b.addEventListener("input", () => {
        (0, getMusicTracks_1.default)().forEach((musicTrack) => {
            musicTrack.applyVolume();
        });
        (0, getNoises_1.default)().forEach((noise) => {
            noise.applyVolume();
        });
    });
    (_c = document.getElementById("music-volume")) === null || _c === void 0 ? void 0 : _c.addEventListener("input", () => {
        (0, getMusicTracks_1.default)().forEach((musicTrack) => {
            musicTrack.applyVolume();
        });
    });
    (_d = document.getElementById("sfx-volume")) === null || _d === void 0 ? void 0 : _d.addEventListener("input", () => {
        (0, getNoises_1.default)().forEach((noise) => {
            noise.applyVolume();
        });
    });
    (_e = document.getElementById("restart")) === null || _e === void 0 ? void 0 : _e.addEventListener("click", () => {
        const mainMusic = (0, getAudioSource_1.default)("music/main");
        mainMusic.stop();
        mainMusic.play(null, null);
        (0, unpause_1.default)();
        (0, startLevel_1.default)();
    });
    (_f = document.getElementById("start-button")) === null || _f === void 0 ? void 0 : _f.addEventListener("click", (e) => {
        var _a;
        (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("title");
        const titleMusic = (0, getAudioSource_1.default)("music/title");
        const mainMusic = (0, getAudioSource_1.default)("music/main");
        state_1.default.isAtTitle = false;
        titleMusic.stop();
        mainMusic.play(null, null);
        (0, startLevel_1.default)();
    });
    (_g = document.getElementById("level-button")) === null || _g === void 0 ? void 0 : _g.addEventListener("click", () => {
        var _a, _b;
        const mainMusic = (0, getAudioSource_1.default)("music/main");
        (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("level");
        const levelIndex = levels_1.default.findIndex((level) => level === state_1.default.level);
        const newLevel = levels_1.default[levelIndex + 1];
        const levelMusic = (0, getAudioSource_1.default)("music/level");
        levelMusic.stop();
        if (newLevel) {
            mainMusic.play(null, null);
            state_1.default.level = newLevel;
            (0, startLevel_1.default)();
        }
        else {
            (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.remove("main");
            const victoryMusic = (0, getAudioSource_1.default)("music/victory");
            victoryMusic.play(null, null);
            state_1.default.won = true;
        }
    });
    (_h = document.getElementById("defeat-button")) === null || _h === void 0 ? void 0 : _h.addEventListener("click", () => {
        var _a;
        const mainMusic = (0, getAudioSource_1.default)("music/main");
        const defeatMusic = (0, getAudioSource_1.default)("music/defeat");
        defeatMusic.stop();
        mainMusic.play(null, null);
        (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("defeat");
        (0, startLevel_1.default)();
    });
    if (screen && pauseButton && unpauseButton) {
        document.addEventListener("keydown", (e) => {
            if (screen.classList.contains("main")) {
                switch (e.code) {
                    case "Enter": {
                        if (screen.classList.contains("paused")) {
                            (0, unpause_1.default)();
                        }
                        else {
                            (0, pause_1.default)();
                        }
                        break;
                    }
                    case "KeyR": {
                        if (e.shiftKey) {
                            const mainMusic = (0, getAudioSource_1.default)("music/main");
                            mainMusic.stop();
                            mainMusic.play(null, null);
                            (0, unpause_1.default)();
                            (0, startLevel_1.default)();
                        }
                        break;
                    }
                }
            }
        });
        screen.appendChild(state_1.default.app.view);
        (0, sizeScreen_1.default)();
        screen.addEventListener("mousedown", (e) => {
            if (e.target instanceof HTMLCanvasElement) {
                (0, handleAction_1.default)();
            }
        });
        screen.addEventListener("mousemove", (e) => {
            if (e.target instanceof HTMLCanvasElement) {
                if ((0, isPaused_1.default)() === false) {
                    state_1.default.mouseScreenCoords = {
                        x: Math.round(e.offsetX / e.target.offsetWidth * gameWidth_1.default),
                        y: Math.round(e.offsetY / e.target.offsetHeight * gameHeight_1.default)
                    };
                }
            }
        });
        screen.addEventListener("keydown", (e) => {
            const heldKeys = state_1.default.heldKeys;
            if (heldKeys.includes(e.code) === false) {
                heldKeys.push(e.code);
                switch (e.code) {
                    case "KeyP": {
                        const anchor = document.createElement("a");
                        anchor.download = "ScatterPaws Screenshot.png";
                        anchor.href = state_1.default.app.renderer.plugins.extract.canvas(state_1.default.app.stage).toDataURL();
                        anchor.click();
                        break;
                    }
                    case "KeyM": {
                        if ((0, gameIsOngoing_1.default)() && (0, levelIsCompleted_1.default)() === false && state_1.default.isInBed === false) {
                            (0, getAudioSource_1.default)("noises/meow").play(null, null);
                        }
                        break;
                    }
                    case "Space": {
                        (0, handleAction_1.default)();
                        break;
                    }
                }
            }
            state_1.default.heldKeys = heldKeys;
        });
        screen.addEventListener("keyup", (e) => {
            const heldKeys = state_1.default.heldKeys;
            const index = heldKeys.indexOf(e.code);
            if (index >= 0) {
                heldKeys.splice(index, 1);
            }
            state_1.default.heldKeys = heldKeys;
        });
        for (const credit of credits_1.default) {
            const element = document.createElement("a");
            element.href = credit.link;
            element.target = "_blank";
            screen.appendChild(element);
            element.style.position = "absolute";
            element.style.left = `${credit.x / gameWidth_1.default * 100}%`;
            element.style.top = `${credit.y / gameHeight_1.default * 100}%`;
            element.style.width = `${credit.width / gameWidth_1.default * 100}%`;
            element.style.height = `${credit.height / gameHeight_1.default * 100}%`;
            element.className = "credit";
        }
        pauseButton.addEventListener("click", () => {
            (0, pause_1.default)();
        });
        unpauseButton.addEventListener("click", () => {
            (0, unpause_1.default)();
        });
    }
    const mainSlider = document.getElementById("main-volume");
    if (socket_1.default) {
        socket_1.default.on("run-id", (runID) => {
            if (document.body.dataset.runId !== runID) {
                location.reload();
            }
        });
    }
    (0, focusScreen_1.default)();
});
exports.default = run;
